// SubMatch (an individual singles/doubles game inside a team-format tie) has
// no winner_side/status field on the live API - only id/parent_match/order/
// is_doubles_match/player_1..4/sets. Whoever won a given sub-match, and the
// overall tally for the tie, has to be derived client-side from its sets and
// is never sent back to the backend (see SubMatchesPanel.js's own comment on
// why - the parent Match's own manually-set winner_side stays the one real,
// saved result).

// Same game-score/tiebreak comparison MatchScoreColumns.js already uses
// per-set to decide which side's score reads as the winner.
const getSetWinner = (set) => {
    const g1 = set?.game_score_1;
    const g2 = set?.game_score_2;
    if (g1 == null || g2 == null) return null;
    if (g1 > g2) return 1;
    if (g2 > g1) return 2;
    const tb1 = set?.tiebreak_score_1;
    const tb2 = set?.tiebreak_score_2;
    if (tb1 != null && tb2 != null) {
        if (tb1 > tb2) return 1;
        if (tb2 > tb1) return 2;
    }
    return null;
};

export const getSubMatchWinnerSide = (subMatch) => {
    let side1Sets = 0;
    let side2Sets = 0;
    (subMatch?.sets || []).forEach(set => {
        const winner = getSetWinner(set);
        if (winner === 1) side1Sets += 1;
        else if (winner === 2) side2Sets += 1;
    });
    if (side1Sets > side2Sets) return 1;
    if (side2Sets > side1Sets) return 2;
    return null;
};

// Plain count of sub-matches decided per side - not weighted by any
// per-sub-match "points value", since that field doesn't exist on the live
// SubMatch API and couldn't be persisted even if entered.
export const tallySubMatches = (subMatches) => {
    let score1 = 0;
    let score2 = 0;
    (subMatches || []).forEach(sm => {
        const winner = getSubMatchWinnerSide(sm);
        if (winner === 1) score1 += 1;
        else if (winner === 2) score2 += 1;
    });
    return { score1, score2 };
};
